export const UserPoolId = 'eu-west-1_6LqHWuqHG';
export const UserPoolClientId = 'lca20satbsdntq5jj811afcuq';
export const GraphQLAPIURL = 'https://api.alm.niotp.com/graphql';
export const IdentityPoolId = 'eu-west-1:ef8839a0-3657-436a-bea5-cf0abef29545';
export const target = 'PRO';
export const region = 'eu-west-1';

// eslint-disable-next-line import/no-dynamic-require
const env = require(`./env.${target}`);

export const config = {
  aws_project_region: region,
  aws_user_pools_id: UserPoolId,
  aws_user_pools_web_client_id: UserPoolClientId,
  aws_appsync_graphqlEndpoint: GraphQLAPIURL,
  aws_appsync_authenticationType: 'AWS_LAMBDA',
  Auth: {
    identityPoolId: IdentityPoolId,
    region,
    userPoolId: UserPoolId,
    userPoolWebClientId: UserPoolClientId,
  },
  Storage: {
    AWSS3: {
      bucket: `alm-graphql-files-bucket-${target.toLowerCase()}-${region}`,
      region,
    },
  },
  oauth: {
    domain: env.authUri,
    redirectSignIn: env.redirectUri,
    redirectSignOut: env.redirectUri,
    responseType: 'token',
    scope: ['openid'],
  },
  env,
};

export default config;
